//#region src/utils/buildSyncList.ts
function e({ connections: e, analyticsSettings: r, destination: i }) {
	let { destinationId: a } = i;
	if (a == null) return console.warn("buildRetentionMeasurementSyncInfo called without valid destinationId"), i.retentionMeasurementSyncInfo || [];
	let o = /* @__PURE__ */ new Map(), s = (e, t, n) => {
		let r = `${e}::${t}`;
		o.has(r) || o.set(r, {
			dbId: e,
			bucketId: t,
			measurements: /* @__PURE__ */ new Set()
		}), o.get(r).measurements.add(n);
	};
	for (let i of e || []) for (let e of i.measurements || []) {
		let i = e.sync, o = e.syncDest?.includes(a);
		if (!(!i || !o && !e.analytics)) for (let i of e.endpoints || []) {
			if (!i.dbId) continue;
			let a = i.dbId;
			e.analytics && n(e, r, a, s), o && t(e, i, a, s);
		}
	}
	let c = Array.from(o.values()).map((e) => ({
		dbId: e.dbId,
		bucketId: e.bucketId,
		extraSync: !1,
		measurementList: Array.from(e.measurements)
	}));
	return [...i.retentionMeasurementSyncInfo?.filter((e) => e.extraSync === !0) || [], ...c];
}
function t(e, t, n, r) {
	let i = e.downsample ? t.bucketIdDsRp : t.bucketIdRp;
	i && r(n, i, e.name || "");
}
function n(e, t, n, r) {
	!t?.detailName || !t?.dstBucketId || r(n, t.dstBucketId, `${t.detailName}${e.name || ""}`);
}
//#endregion
export { e as t };

//# sourceMappingURL=buildSyncList-Bn1PFQeU.js.map